import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { loanPledge } from '@/config/sensors';
import { saPushEvent } from '@/utils/sensors';
import { replace } from '@/locales/i18n';
import { noDmainUrl } from '@/utils/url';
export default {
  props: {
    name: {
      type: String,
      default: 'loan'
    }
  },
  setup() {
    const store = useStore();
    const {
      t
    } = useI18n({
      useScope: 'global'
    });
    const isLogin = computed(() => store.state.user.userstate === 1);
    const isVIP = computed(() => store.getters['user/isVIP']);
    const isSub = computed(() => store.getters['user/isSub']);
    const userInfo = computed(() => store.state.loan.user);
    const progressOrderQty = computed(() => store.state.loan.progressOrderQty);
    const tabSensorsMap = {
      Loan: 'Borrowing',
      Order: 'OutstandingLoans',
      Assets: 'BalanceSheet',
      Vip: 'VipLoan'
    };
    const orderLink = computed(() => isLogin.value ? '/user/assets/order/pledge-borrow-return/outstand' : replace('/login/'));
    const announcementLink = computed(() => isLogin.value ? '/announcement-info/loan/' : replace('/login/'));
    const handleTab = context => {
      const {
        name
      } = context.props;
      store.commit('loan/SET_TAB', name);
      saPushEvent(loanPledge.tab, {
        page_name: loanPledge.home,
        plate_area: 'Header',
        item_name: tabSensorsMap[name]
      });
    };
    const methods = {
      handleOpenVideo() {
        store.commit('loan/SET_OPEN_VIDEO', true);
      }
    };
    return {
      t,
      ...methods,
      progressOrderQty,
      orderLink,
      announcementLink,
      loanPledge,
      isLogin,
      handleTab,
      replace,
      noDmainUrl,
      userInfo,
      isVIP,
      isSub
    };
  }
};